import { Link } from 'react-router-dom';
import { prizes } from '@/mocks/siteData';

export default function PrizeSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            丰厚奖励
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            多级奖励体系，总有一款属于你
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            每日赛、周决赛、月总决赛，层层递进，奖励不断升级
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {prizes.map((prize) => (
            <div
              key={prize.id}
              className="bg-background-50 rounded-2xl p-6 md:p-7 text-center border border-background-200 hover:border-accent-200 transition-all duration-300"
            >
              <div className={`w-14 h-14 mx-auto flex items-center justify-center rounded-full ${prize.color} text-white mb-4`}>
                <i className={`${prize.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {prize.title}
              </h3>
              <p className="text-sm text-foreground-500">
                {prize.prize}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/prizes"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-accent-600 transition-all duration-200 no-underline cursor-pointer"
          >
            查看完整奖品详情
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}